export default "__VITE_ASSET__a81ef201__"